function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconRotate2Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16 1.14L11.738 5.4l4.26 4.26V1.14z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.736 6.997c1.09-.37 2.26-.572 3.476-.572C23.17 6.425 28 11.255 28 17.212 28 23.17 23.17 28 17.212 28c-.267 0-.533-.01-.796-.029l-1.771 1.771c.83.17 1.688.258 2.567.258C24.275 30 30 24.275 30 17.212c0-7.062-5.725-12.787-12.788-12.787-1.783 0-3.481.365-5.024 1.024l1.548 1.548z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.655 12.828l-5.827 5.828 5.827 5.827 5.828-5.828-5.828-5.827zM2 18.656l8.655 8.655 8.656-8.655L10.656 10 2 18.655z",
    fill: props.color
  }));
}

export default SvgIconRotate2Filled;